<template>
<section class="transparency">
        <div class="transparency-box">
            <h2>We're Building This With You</h2>
            <p>Pabu already handles your daily operations—customer support, scheduling, and communications.</p>
            <p><strong>We're now developing the business intelligence features</strong> you saw above. We want to build exactly what entrepreneurs need.</p>
            
            <ul class="benefits-list">
                <li>Get early access when we launch</li>
                <li>Help shape which insights matter most to you</li>
                <li>Lock in founding member pricing</li>
            </ul>

            <div class="beta-callout">
                🚀 Launching Q1 2026 — We're looking for interested entrepreneurs to join our beta program
            </div>

            <a href="#waitlist" class="cta-button" style="margin-top: 2rem;">Join the Beta Program</a>
        </div>
    </section>    
</template>
  
  <script>
  export default {
    name: "TransparencySection"
  };
  </script>
  
  <style scoped>

  </style>
  